import { api } from "@/api";
import {
  UpdateLeagueMappingParams,
  LeagueProviderMappingDto,
} from "@/types/ApiResponses/League";

export const updateLeagueMapping = async (
  params: UpdateLeagueMappingParams
): Promise<LeagueProviderMappingDto> => {
  const { leagueId, id, ...body } = params;
  const res = await api.client.patch(
    `/leagues-new/${leagueId}/mappings/${id}`,
    body
  );
  return res.data;
};
